import { Component } from '@angular/core';
import { AppService } from '@services/app.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent {
  public user;

  constructor(private appService: AppService) {
    this.user = this.appService.user;
  }

  logout() {
    this.appService.logout();
  }

  formatDate(date: string) {
    return DateTime.fromRFC2822(date).toFormat('dd LLL yyyy');
  }
}
